<div>
  <h5>Edit Product {{ name }}</h5>
</div>

<router-outlet></router-outlet>
